import _ from "lodash";
import { connect } from "react-redux";
import React, { Component } from "react";
import { Label } from "react-bootstrap";
import FormElement from "components/FormElement";
import FccLink from "components/FccLink";
import DpSwVersion from "containers/testResult/DpSwVersion";
import { handleInputChange } from "actions/request";
import { isCTIAUser } from "helpers/Users";
import { hasStringValue } from "helpers/RequestHelper";
import { emptyMsg } from "helpers/FormHelper";
import { hasTestResults } from "helpers/RequestTestsHelper";

class DeviceInfoExtended extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFccId: false,
      showDescChange: false,
      hasTestResults: false
    };
  }

  componentDidMount() {
    this.setState({
      showFccId: this.hasFccId(),
      showDescChange: this.hasDescChange()
    });
  }

  isValidationRequired = () => {
    return this.props.user.canEditRequest;
  };

  hasFccId() {
    return hasStringValue(this.props.request, "fccId");
  }

  hasHwVersion() {
    return hasStringValue(this.props.request, "hwVersion");
  }

  hasSwVersion() {
    return hasStringValue(this.props.request, "swVersion");
  }

  hasDescChange() {
    return hasStringValue(this.props.request, "descriptionOfChange");
  }

  showHw() {
    if (this.hasHwVersion()) return true;

    const testStatus = this.props.tests[0].requestteststatusid;

    return hasTestResults(testStatus);
  }

  showSw() {
    if (this.hasHwVersion()) return true;

    const testStatus = this.props.tests[0].requestteststatusid;

    return hasTestResults(testStatus);
  }

  validateFccId() {
    if (!this.isValidationRequired()) return null;
    return this.state.showFccId && hasStringValue(this.props.request, "fccId")
      ? null
      : "error";
  }

  validateHwVersion() {
    if (!this.isValidationRequired()) return null;

    return this.hasHwVersion() ? null : "error";
  }

  validateSwVersion() {
    if (!this.isValidationRequired()) return null;

    return this.hasSwVersion() ? null : "error";
  }

  validateDescChange() {
    if (!this.isValidationRequired()) return null;
    return this.state.showDescChange &&
      hasStringValue(this.props.request, "descriptionOfChange")
      ? null
      : "error";
  }

  getVersionValue(fieldName) {
    const { request, user } = this.props;

    if (user.canEditRequest || !_.isEmpty(request[fieldName]))
      return request[fieldName];

    return <Label>REQUIRED</Label>;
  }

  render() {
    const { request, handleInputChange, user } = this.props;
    const { fccId, descriptionOfChange } = request;
    const isEditable = user.canEditRequest;
    const inputType = isEditable ? "text" : "";
    const fccIdValue = isEditable ? fccId : <FccLink fccId={fccId} />;

    // only CTIA Staff able to edit FCC ID field
    const fccIdFieldType = isEditable && isCTIAUser(user) ? "text" : "";

    const { showFccId, showDescChange } = this.state;

    if (request.id > 0) {
      return [
        <FormElement
          key={1}
          id="fccId"
          label="FCC ID"
          value={fccIdValue}
          show={showFccId}
          editable={isEditable}
          type={fccIdFieldType}
          onChange={handleInputChange}
          validationState={this.validateFccId()}
          validationMessage={emptyMsg}
          maxLength="50"
        />,
        <FormElement
          key={2}
          id="hwVersion"
          label="HW Version"
          value={this.getVersionValue("hwVersion")}
          show={this.showHw()}
          editable={isEditable}
          type={inputType}
          onChange={handleInputChange}
          validationState={this.validateHwVersion()}
          validationMessage={emptyMsg}
          maxLength="50"
        />,
        <FormElement
          key={3}
          id="swVersion"
          label="SW Version"
          value={this.getVersionValue("swVersion")}
          show={this.showSw()}
          editable={isEditable}
          type={inputType}
          onChange={handleInputChange}
          validationState={this.validateSwVersion()}
          validationMessage={emptyMsg}
          maxLength="50"
        />,
        <DpSwVersion key={4} />,
        <FormElement
          key={5}
          id="descriptionOfChange"
          label="Description of Change"
          value={descriptionOfChange}
          show={showDescChange}
          editable={isEditable}
          type={inputType}
          onChange={handleInputChange}
          validationState={this.validateDescChange()}
          validationMessage={emptyMsg}
        />
      ];
    }

    return null;
  }
}

function mapStateToProps({ request, tests, user }) {
  return { request, tests, user };
}

export default connect(mapStateToProps, { handleInputChange })(
  DeviceInfoExtended
);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/DeviceInfoExtended.js